const AccountBeneficiaryDetails = () =>
    import(/* webpackChunkName: "AccountBeneficiaryDetails" */ '@/views/shared/related-beneficiaries/account-beneficiary-details');

export default {
    name: 'RelatedBeneficiaries',
    components: {
        AccountBeneficiaryDetails
    },

    /**
     * @override
     */
    data() {
        return {
            beneficiaries: [],
            fields: [
                {
                    key: 'given_name',
                    label: 'Nombre'
                },
                {
                    key: 'family_name',
                    label: 'Apellidos'
                },
                {
                    key: 'document_id',
                    label: 'Nº de documento'
                },
                {
                    key: 'key_product',
                    label: 'Plan'
                },
                {
                    key: 'actions',
                    label: ''
                }
            ],
            showForm: false
        };
    },
    props: {
        id: {
            type: String,
            required: false
        },
        accountStatus: {
            type: String,
            required: false,
            default: null
        }
    },
    methods: {
        /**
         * Obtenemos los intervinientes relacionados con la cuenta/operación
         */
        fetchData() {
            // Get interveners
            this.$accountsService.getBeneficiaries(this.id)
                .then(response => {
                    this.beneficiaries = response.data.account_beneficiaries;
                })
                .catch(error => console.error(error));
        },
        /**
         * Creates a bank account
         * @param {Object} accountBeneficiaryData Datos del beneficiario
         */
        createAccountBeneficiary(accountBeneficiaryData) {
            const payload = {
                key_product: accountBeneficiaryData.key_product,
                beneficiaries: [accountBeneficiaryData]
            };
            this.$accountsService
                .createBeneficiaries(this.id, payload)
                .then(() => {
                    this.$toast.success(`201`, `El beneficiario ha sido creada con éxito.`);
                    this.fetchData();
                })
                .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
        },
        /**
         * Updates a bank account
         * @param {Object} accountBeneficiaryData Datos actualizados del beneficiario
         */
        updateAccountBeneficiary(accountBeneficiaryData) {
            this.$accountsService
                .updateAccountBeneficiary({}, accountBeneficiaryData, this.id, accountBeneficiaryData.uuid)
                .then(() => {
                    this.$toast.success(`200`, `El beneficiario ha sido actualizada con éxito.`);
                    this.fetchData();
                    this.$root.$emit('refresh_bastanteo_groups');
                })
                .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
        },
        /**
         * Deletes a bank account
         * @param {Object} beneficiaryUUID Uuid del beneficiario
         */
        deleteAccountBeneficiary(beneficiaryUUID) {
            this.$accountsService
                .deleteAccountBeneficiary({}, this.id, beneficiaryUUID)
                .then(() => {
                    this.$toast.success(`200`, `El beneficiario ha sido borrada con éxito.`);
                    this.fetchData();
                })
                .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
        },
        /**
         * Mostramos el formulario para añadir una nueva cuenta bancaria
         */
        toggleForm() {
            this.showForm = !this.showForm;
        }
    },

    /**
     * @override
     */
    beforeMount() {
        this.fetchData();
    }
};
